import React, { useEffect, useState } from 'react';
import { FormControl, FormHelperText, Grid, FormLabel, FormControlLabel } from '@material-ui/core';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../../actions';
import { useForm, Controller } from 'react-hook-form';
import { IFormProps } from './section.interface';
import { Button, Divider, Stack, TextField, Radio, RadioGroup, Typography, Box } from '@mui/material';
import {Colors} from "../../../../../enums/enums";

const Section2: React.FC<IFormProps> = ({ step, setStep }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });
  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: state?.formDetails?.all
  });
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ formDetails: { all: partialData } } as any);
    setStep(step - 1);
  };

  const onSubmit = (data: any) => {
    actions.updateAction({ formDetails: { all: data } } as any);
    console.log('Data', data);
    setStep(step + 1);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Divider sx={{ mb: 6, ml: 4 }} />
        <Grid className={classes.formContent} container spacing={5} alignItems="center" justifyContent="center">
          <Stack sx={{ width: '667px', ml: 4 }} spacing={3}>
            <Box>
              <FormControl style={{ width: '100%' }}>
                <FormLabel className={classes.formLabel}>Company *</FormLabel>
                <Controller
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter your company name *"
                      fullWidth
                      variant="outlined"
                      color="success"
                    />
                  )}
                  name="company"
                  control={control}
                  rules={{ required: true }}
                />
                {errors?.company?.type === 'required' && (
                  <FormHelperText className={classes.errorText}>Required</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Box>
              <FormControl style={{ width: '100%' }}>
                <FormLabel className={classes.formLabel}>Current Job Title? *</FormLabel>
                <Controller
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="Enter your current job title"
                      fullWidth
                      variant="outlined"
                      color="success"
                    />
                  )}
                  name="title"
                  control={control}
                  rules={{ required: true }}
                />
                {errors?.title?.type === 'required' && (
                  <FormHelperText className={classes.errorText}>Required</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Box>
              <FormControl>
                <FormLabel className={classes.formLabel}>Years of Experience in Your Field *</FormLabel>
                <Controller
                  render={({ field }) => (
                    <RadioGroup row {...field}>
                      {['0-5', '6-10', '11-15', '16-20', '21+'].map((experience, index) => (
                        <FormControlLabel
                          key={index}
                          value={experience}
                          control={<Radio color="success" />}
                          label={experience}
                        />
                      ))}
                    </RadioGroup>
                  )}
                  name="experience"
                  control={control}
                  rules={{ required: true }}
                />
                {errors?.experience?.type === 'required' && (
                  <FormHelperText className={classes.errorText}>Required</FormHelperText>
                )}
              </FormControl>
            </Box>

            <Box>
              <FormControl style={{ width: '100%' }}>
                <FormLabel className={classes.formLabel}>LinkedIn Profile URL *</FormLabel>
                <Typography sx={{ color: Colors.TextElevated, fontSize: '14px', mb: 2 }}>
                  Copy and paste the entire link to your profile including https://
                </Typography>
                <Controller
                  render={({ field }) => (
                    <TextField
                      {...field}
                      placeholder="e.g. https://www.linkedin.com/in/your-profile/"
                      fullWidth
                      variant="outlined"
                    />
                  )}
                  name="linkedin"
                  control={control}
                  rules={{ required: true }}
                />
                {errors?.linkedin?.type === 'required' && (
                  <FormHelperText className={classes.errorText}>Required</FormHelperText>
                )}
              </FormControl>
            </Box>
          </Stack>
          <Grid item className={classes.buttonContainter}>
            <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
              BACK
            </Button>
          </Grid>

          <Grid item className={classes.buttonContainter}>
            <Button className={classes.button} variant="contained" color="success" type="submit">
              NEXT
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

export default Section2;
